/* src/app/location-users/location-users.component.scss */
.search-bar {
  width: 328px;
  padding-right: 32px;
  margin-bottom: 16px;
}
.search-bar .display-count {
  padding-top: 9px;
  font-size: 14px;
  font-style: italic;
  line-height: 1.2em;
}
.no-new-requests-message {
  margin-top: 58px;
  font-style: italic;
  color: #404040;
}
.no-new-requests-message .meatball {
  display: inline-block;
  color: #242424;
  font-style: normal;
  width: 28px;
  height: 28px;
  background-color: #F88C00;
  border-radius: 50%;
  text-align: center;
  line-height: 28px;
}
.buttons {
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  align-items: flex-start;
}
.buttons button {
  margin-top: 28px;
  height: 36px;
  background-color: #00857D;
  border-radius: 100px;
  color: white;
  border: 0;
  padding-right: 28px;
  padding-left: 28px;
}
.buttons button.ups-icon:before {
  margin-right: 8px;
}
.buttons .exportRequestsButton {
  margin-right: 12px;
}
.buttons .exportRequestsButton:before {
  font-family: upsicons, fantasy !important;
  content: "\e63a" !important;
  color: white;
  margin-right: 8px;
}
.sort-section {
  display: flex;
  margin-bottom: 16px;
}
.sort-section .location-sort {
  width: 332px;
}
/*# sourceMappingURL=location-users.component.css.map */
